/* eslint-disable @typescript-eslint/no-explicit-any */
import { EthereumClient, modalConnectors, walletConnectProvider } from '@web3modal/ethereum';
import { NETWOKMB } from 'config/env';
import { Chain, configureChains, createClient } from 'wagmi';
import {
  arbitrum,
  arbitrumGoerli,
  avalanche,
  bsc,
  fantom,
  goerli,
  mainnet,
  polygon,
  polygonMumbai,
} from 'wagmi/chains';
// import { Chain } from '@web3modal/ethereum';

const defaultChains = [
  mainnet,
  goerli,
  arbitrum,
  arbitrumGoerli,
  avalanche,
  bsc,
  fantom,
  polygon,
  polygonMumbai,
];
const customChains: Chain[] = [
  {
    testnet: NETWOKMB.testnet,
    id: NETWOKMB.chainIdNumber,
    name: NETWOKMB.chainName,
    network: NETWOKMB.chainName,
    nativeCurrency: {
      name: NETWOKMB.currencyName,
      symbol: NETWOKMB.currencySymbol,
      decimals: 18,
    },
    blockExplorers: {
      default: {
        name: 'Polygon Scan',
        url: NETWOKMB.blockExplorer,
      },
    },
    rpcUrls: {
      default: { http: [NETWOKMB.rpc] },
    },
  },
];

const { chains, provider } = configureChains(customChains, [
  walletConnectProvider({ projectId: '0b9eb0cbd0d1fe226a4266ebb4c21e1d' }),
]);

export const wagmiClient = createClient({
  autoConnect: true,
  connectors: modalConnectors({ appName: 'dmtp', chains }),
  provider,
});

export const ethereumClient = new EthereumClient(wagmiClient, chains);
